import { setAccessToken, hasAuthCookies, getRefreshToken } from "./tokens";
import { logoutUser } from "../actions";
import { HttpMethod, HttpError } from "libs";
import { Store } from "redux";
import { RootState } from "../reducers";

interface TokenRefreshResponse {
	access_token: string;
	expires_in: number;
	token_type: string;
	scope: null;
	refresh_token: string;
}

export interface ServiceRefreshResponse {
	access_token: string;
	refresh_token: string;
	tokenExpires: number;
}

export class TokenService {
	refreshing: boolean = false;
	tokenExpires: number;
	store: Store;
	tokenRefreshOffset: number;

	constructor(store: Store, tokenRefreshOffset: number = 30) {
		this.store = store;
		this.tokenRefreshOffset = tokenRefreshOffset;
	}

	usesToken(): boolean {
		const { auth } = this.store.getState() as RootState;

		return auth.authenticated;
	}

	shouldRefresh(): boolean {
		if (this.refreshing) {
			return false;
		}

		const { auth } = this.store.getState() as RootState;

		return (
			auth.authenticated && hasAuthCookies() && Date.now() + this.tokenRefreshOffset * 1000 >= auth.tokenExpires
		);
	}

	getTokenExpiration(): Date {
		const { auth } = this.store.getState() as RootState;
		return new Date(auth.tokenExpires);
	}

	isRefreshing(): boolean {
		return this.refreshing === true;
	}

	private async refreshAuthToken(): Promise<TokenRefreshResponse> {
		const res = await fetch(process.env.REACT_APP_TOKEN_REFRESH_URL, {
			method: HttpMethod.POST,
			mode: "cors",
			redirect: "follow",
			headers: {
				"Content-Type": "application/json;charset=utf-8",
			},
			credentials: "include",
			body: JSON.stringify({
				refresh_token: getRefreshToken() || null,
				grant_type: "refresh_token",
				client_id: process.env.REACT_APP_CLIENT_ID,
				client_secret: process.env.REACT_APP_CLIENT_SECRET,
			}),
		});

		if (res.ok) {
			const json = await res.json();
			return json;
		}

		throw new HttpError(res);
	}

	public async refresh(): Promise<ServiceRefreshResponse> {
		//const refreshToken = getRefreshToken();
		//if (refreshToken) {
		if (!this.refreshing) {
			this.refreshing = true;
			this.store.dispatch({
				type: "TOKEN_REFRESHING",
				refreshing: this.refreshing
			});
			try {
				const { access_token, refresh_token, expires_in } = await this.refreshAuthToken();
				setAccessToken(access_token);

				const tokenExpires = Date.now() + expires_in * 1000;

				this.store.dispatch({
					type: "TOKEN_REFRESHED",
					tokenExpires,
				});

				this.refreshing = false;

				return { access_token, refresh_token, tokenExpires };
			} catch (err) {
				logoutUser(this.store.dispatch);
				//throw err;
			} finally {
				this.refreshing = false;
				this.store.dispatch({
					type: "TOKEN_REFRESHING",
					refreshing: this.refreshing
				});
			}
		} else {
			//throw new Error("already refreshing");
		}
		/*	} else {
			this.refreshing = false;
			logoutUser(this.store.dispatch);
			//throw new Error("no refresh token, logging out");
		}*/
	}
}
